import { ChangeDetectorRef, Component, OnInit } from "@angular/core";
import { UtilsService } from "../../../../../auth/service/utils.service";
import { locale as italian } from "../../../../../i18n/it";
import { AbsencesService } from "../../../../../auth/service/absences.service";
import { AuthenticationService } from "../../../../../auth/service";
import { IContentHeader } from "app/layout/components/content-header/content-header.component";

@Component({
  selector: "app-absences-type-list",
  templateUrl: "./absences-type-list.component.html",
  styleUrls: ["./absences-type-list.component.scss"],
})
export class AbsencesTypeListComponent implements OnInit {
  public tableLimit: number = 10;
  public searchKeyword: string = "";
  public contentHeader: IContentHeader;
  public config: any;
  public absences: any;
  public filterRequireNote: number = 3;
  public filterRequireFile: number = 3;
  public filterTypeAbsence: string = "0";
  public filteredAbsences: any = [];

  constructor(
    public _absencesService: AbsencesService,
    public _utilService: UtilsService,
    public _changeDetectorRef: ChangeDetectorRef,
    public _authenticationService: AuthenticationService,
  ) {
    this.contentHeader = {
      headerTitle: italian.data.MENU.ABSENCES_TYPE,
      actionButton: false,
      breadcrumb: {
        type: "",
        links: [
          {
            name: "Home",
            isLink: true,
            link: "/",
          },
          {
            name: italian.data.MENU.MANAGE,
            isLink: true,
            link: "/dashboard/platform-management",
          },
          {
            name: italian.data.MENU.ABSENCES_TYPE,
            isLink: false,
          },
        ],
      },
    };
    this.config = {
      columns_sm: [
        {
          value: "name",
          text: italian.data.FIRSTNAME,
          width: 300,
          sortable: true,
        },
        {
          value: "require_note",
          text: italian.data.DATATABLE_COLUMNS.REQUIRE_NOTE,
          width: 150,
          sortable: true,
        },

        {
          value: "require_file",
          text: italian.data.DATATABLE_COLUMNS.REQUIRE_FILE,
          width: 150,
          sortable: true,
        },
        "",
      ],
    };
  }

  async ngOnInit() {
    await this.loadAbsences();
  }

  async loadAbsences() {
    this.absences = await this._absencesService.getTypeList();
    this.absencesList();
  }

  absencesList() {
    let items: any = this.absences;
    const keywords: string = this.searchKeyword.trim().toLowerCase();
    if (keywords.length > 0) {
      items = this.absences.filter((item: any) => item.name.toLowerCase().includes(this.searchKeyword.trim().toLowerCase()));
    }
    if (this.filterRequireNote !== 3) {
      items = this.absences.filter((item: any) => item.require_note == this.filterRequireNote);
    }
    if (this.filterRequireFile !== 3) {
      items = this.absences.filter((item: any) => item.require_file == this.filterRequireFile);
    }
    if (this.filterTypeAbsence !== '0') {
      items = this.absences.filter((item: any) => item.type && item.type == this.filterTypeAbsence);
    }
    this.filteredAbsences = items;
  }

  updateTableLimit(event: { target: { value: string } }) {
    this.tableLimit = Number(event.target.value);
  }

  async deleteTypeAbsence(selectedAbsence: any) {
    if (!this._authenticationService.hasCapability("delete_absence_type")) {
      window.history.back();
      return false;
    }
    let deleteText: string = await this._utilService.translate("ALERT.CONFIRM_DELETE_TEXT");
    deleteText += await this._utilService.translate("ALERT.CONFIRM_DELETE_THIS_OBJECT");
    deleteText += selectedAbsence.name;
    if (selectedAbsence.used < 1) {
      await this._utilService.showSWALDeleteConfirmation({ text: deleteText }).then(async (result) => {
        if (result.value) {
          await this._absencesService
            .deleteType(selectedAbsence.id)
            .then(async () => {
              await this._utilService.showPopupItemDeleted().then(async () => {
                await this.loadAbsences();
              });
            })
            .catch(() => this._utilService.showSWALError({ text: "ERROR_DELETE_TYPE_ABSENCE" }));
        } else if (result.isDismissed) {
          await this._utilService.showSWALError({
            title: "ABORTED_TITLE",
            text: "ABORTED_TEXT",
          });
        }
      });
    } else {
      await this._utilService.showSWALError({ text: "ERROR_TYPE_ABSENCE_USED" });
    }
  }
}
